(function () {
  'use strict';

  if (window.YFCollectionDeliveryEstimatesLoaded) return;
  window.YFCollectionDeliveryEstimatesLoaded = true;

  function numberFromAttribute(element, name, fallback) {
    var value = parseInt(element.getAttribute(name), 10);
    return Number.isFinite(value) ? value : fallback;
  }

  function addBusinessDays(startDate, daysToAdd) {
    var date = new Date(startDate);
    var added = 0;

    while (added < daysToAdd) {
      date.setDate(date.getDate() + 1);
      var day = date.getDay();
      if (day !== 0 && day !== 6) added += 1;
    }

    return date;
  }

  function addCalendarDays(startDate, daysToAdd) {
    var date = new Date(startDate);
    date.setDate(date.getDate() + daysToAdd);
    return date;
  }

  function formatDate(date, mode) {
    return date.toLocaleDateString('en-CA', {
      month: 'short',
      day: 'numeric'
    }).replace(',', '');
  }

  function updateEstimate(element) {
    if (!element || element.getAttribute('data-yf-delivery-ready') === 'true') return;

    var mode = element.getAttribute('data-yf-delivery-estimate');
    var range = element.querySelector('[data-yf-delivery-range]');
    if (!mode || !range) return;

    var startDays = numberFromAttribute(element, 'data-yf-delivery-start', mode === 'calendar' ? 7 : 2);
    var endDays = numberFromAttribute(element, 'data-yf-delivery-end', mode === 'calendar' ? 21 : 7);
    var today = new Date();
    var start;
    var end;
    var separator;

    if (mode === 'calendar') {
      start = addCalendarDays(today, startDays);
      end = addCalendarDays(today, endDays);
      separator = ' – ';
    } else {
      start = addBusinessDays(today, startDays);
      end = addBusinessDays(today, endDays);
      separator = ' – ';
    }

    range.textContent = formatDate(start, mode) + separator + formatDate(end, mode);
    element.setAttribute('data-yf-delivery-ready', 'true');
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches('[data-yf-delivery-estimate]')) {
      updateEstimate(scope);
    }

    Array.prototype.forEach.call(
      scope.querySelectorAll('[data-yf-delivery-estimate]'),
      updateEstimate
    );
  }

  function start() {
    scan(document);

    if (!window.MutationObserver || !document.body) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
          if (node && node.nodeType === 1) scan(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
